<template lang="pug">
.menu
  .row.head-area
    .logo
    .btn.close(@click='$emit("close")')
  .row.profile-area(@click='editInfo')
    .col.names
      .row.name {{ user.data.name }} {{ user.data.surname || '' }}
      .row.refreshed Refreshed {{ user.recentLogged }}
    .col.photo-default(v-if='!user.data._attachments')
    img.col.photo(v-if='user.data._attachments', :src='user.attachment')
  .row.menu-area
    menu-item(v-for='i in menuItemsForAdmin', :key='i.label', :item='i', @selected='onSelectItem', :extended='i.extended', @update:extended='(e) => { onUpdateExtended(i, e) }')
    .logout-wrap
      .logout(@click='onClickLogout')
</template>

<style lang="less">
@import '~@/assets/common.less';
.menu:extend(.full-screen) {
  background-color: white;
  .row:extend(.full-width, .relative) {
    display: block;
    margin: 0px;
    clear: both;
    .col:extend(.full-height) {
      padding: 0px;
      float: left;
    }
  }
  .head-area {
    height: 63px;
    > *:extend(.absolute) {}
    .logo {
      background: url(https://www.lsevkorea.com:40010/_html/marcket/images/ci_ci_img.png) no-repeat left;
      background-size: auto 100%;
      width: 97px;
      height: 28px;
      top: 11px;
      left: 20px;
    }
    .btn.close {
      background: url(~@/assets/imgs/menu_close.png) no-repeat center;
      width: 31px;
      height: 31px;
      top: 10px;
      right: 10px;
      background-size: 100%;
    }
  }
  .profile-area {
    height: 64px;
    margin-bottom: 20px;
    .photo-default {
      margin-left: 20px;
      width: 64px;
      border-radius: 50%;
      object-fit: cover;
      background-image: url('~@/assets/imgs/icon_userImg.png');
      background-size: auto 100%;
    }
    .photo {
      margin-left: 20px;
      width: 64px;
      border-radius: 50%;
      object-fit: cover;
      background-size: auto 100%;
    }
    .names:extend(.absolute, .full-width) {
      padding-left: 95px;
      .name {
        height: 21px;
        object-fit: contain;
        font-family: Poppins;
        font-size: 15px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        text-align: left;
        color: #0a1e5b;
      }
      .refreshed {
        margin-top: 5px;
        height: 15px;
        object-fit: contain;
        font-family: Poppins;
        font-size: 10px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        text-align: left;
        color: #7d8282;
      }
    }
  }
  .menu-area {
    height: calc(100% - 147px);
    overflow-y: scroll;
    background-color: #0a1e5b;
    padding-top: 15px;
    .logout-wrap:extend(.relative, .full-width) {
      height: 77px;
      border-top: solid 5px white;
      padding: 5px 0px 0px 0px;
      .logout:extend(.full-widthheight) {
        background: url(~@/assets/imgs/menu_logout.png) no-repeat left;
        background-size: 375px 52px;
      }
    }
  }
}
</style>

<script>
import MenuItem from './menuItem'
import { mapState } from 'vuex'

export default {
  components: { MenuItem },
  computed: {
    ...mapState(['user']),
    menuItemsForAdmin () {
      if (this.user.data.position !== 'admin') {
        return this.items.reduce((acc, m) => { if (m.label === 'Administration') { } else acc.push(m); return acc }, [])
      }
      return this.items
    }
  },
  props: [ 'items' ],
  data: () => ({
  }),
  methods: {
    onSelectItem (i, p) {
      this.foldAll()
      if (p) { p.extended = true }
      this.$emit('goto', i.href)
    },
    onClickLogout () {
      this.$emit('logout')
    },
    foldAll () {
      this.items.forEach(itm => { itm.extended = false })
    },
    async onUpdateExtended (i, e) {
      this.foldAll()
      i.extended = e
    },
    editInfo () {
      this.$emit('goto', '/Edit/Infomation')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menu/index.vue